(function () {

let $b8f9b7833fa37166$var$toggleBtn = document.querySelector("#navbar-toggle");
let $b8f9b7833fa37166$var$collapse = document.querySelector("#navbar-collapse");
$b8f9b7833fa37166$var$toggleBtn.onclick = ()=>{
    $b8f9b7833fa37166$var$collapse.classList.toggle("hidden");
    $b8f9b7833fa37166$var$collapse.classList.toggle("flex");
};
// add active class on navbar item if it is the current page
let $b8f9b7833fa37166$var$navbarItems = document.querySelectorAll("#navbar-collapse a");
$b8f9b7833fa37166$var$navbarItems.forEach((item)=>{
    if (window.location.href === item.href) {
        item.classList.add("active");
        item.classList.remove("nav");
    } else {
        item.classList.remove("active");
        item.classList.add("nav");
    }
});
// add year to #footer-year
let $b8f9b7833fa37166$var$date = new Date();
let $b8f9b7833fa37166$var$year = $b8f9b7833fa37166$var$date.getFullYear();
let $b8f9b7833fa37166$var$footerYear = document.querySelector("#footer-year");
$b8f9b7833fa37166$var$footerYear.innerHTML = $b8f9b7833fa37166$var$year;
// Video Modal Functionality
document.addEventListener('DOMContentLoaded', ()=>{
    const videoModal = document.getElementById('video-modal');
    const videoPlayer = document.getElementById('modal-video-player');
    if (videoModal && videoPlayer) {
        // Get all buttons that open the modal
        const modalToggleButtons = document.querySelectorAll('[data-modal-toggle="video-modal"]');
        // Add click event listeners to each button
        modalToggleButtons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                // Get the video source from the button's data attribute
                const videoSrc = button.getAttribute('data-video-src');
                // Set the video source
                if (videoSrc) {
                    videoPlayer.src = videoSrc;
                    videoPlayer.load(); // Reload the video element
                }
                // Toggle the modal visibility
                videoModal.classList.toggle('hidden');
                videoModal.classList.toggle('flex');
                // If opening the modal, add overflow hidden to body
                if (!videoModal.classList.contains('hidden')) document.body.classList.add('overflow-hidden');
                else {
                    document.body.classList.remove('overflow-hidden');
                    // Pause video when modal is closed
                    videoPlayer.pause();
                }
            });
        });
        // Close modal when clicking outside the content
        videoModal.addEventListener('click', (e)=>{
            if (e.target === videoModal) {
                videoModal.classList.add('hidden');
                videoModal.classList.remove('flex');
                document.body.classList.remove('overflow-hidden');
                videoPlayer.pause();
            }
        });
        // Close modal with Escape key
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && !videoModal.classList.contains('hidden')) {
                videoModal.classList.add('hidden');
                videoModal.classList.remove('flex');
                document.body.classList.remove('overflow-hidden');
                videoPlayer.pause();
            }
        });
    }
});

})();
//# sourceMappingURL=index.637cf6b5.js.map
